<script setup>
import { computed } from 'vue'
import { useMemberStore } from '@stores/member'
import { usePremiumStore } from '@stores/premium'
import NavAvatar from './nav-avatar'

const memberStore = useMemberStore()
const premiumStore = usePremiumStore()

const member = computed(() => memberStore.currentMember || {})
const isPremium = computed(() => premiumStore.isPremium)

// D10: name over email; email alone when the profile has no name (never the same line twice).
// The avatar itself is the NavAvatar in the header-art slot (D17), ringed for subscribers.
const header = computed(() => {
    const name = [member.value.firstName, member.value.lastName].filter(Boolean).join(' ')
    return {
        imageType: 'avatar',
        title: name || member.value.email,
        ...(name && { subtitle: member.value.email }),
    }
})

// PRD rule 10: Account · Settings · Log out. Account keeps opening in a new tab as it did
// on master (D11 — one attribute to drop if the call changes).
const items = [
    { id: 'account', label: 'Account', to: { name: 'account/overview' }, target: '_blank' },
    { id: 'settings', label: 'Settings', to: { name: 'settings' } },
    { divider: true },
    { id: 'logout', label: 'Log out', to: { name: 'logout' } },
]
</script>

<template>
    <BaseContextMenu
        class="account-menu"
        :items="items"
        :header="header"
        trigger-label="Account"
    >
        <template #trigger="{ toggle, attrs }">
            <button
                v-bind="attrs"
                class="account-menu-trigger"
                type="button"
                aria-label="Account"
                @click="toggle"
            >
                <NavAvatar
                    :member="member"
                    :premium="isPremium"
                />
            </button>
        </template>
        <template #header-art>
            <NavAvatar
                :member="member"
                :premium="isPremium"
            />
        </template>
    </BaseContextMenu>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.account-menu-trigger {
    display: inline-flex;
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: 0;
    border-radius: $radius-full;

    @include focusRing;
}
</style>
